var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_33866_5230)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.0976,
    cy: 20.0976,
    r: 16.0976,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.0976,
    cy: 20.0976,
    r: 15.7049,
    stroke: "#CD2A3F",
    strokeWidth: 0.785247
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2402 18.5394H27.6258V15.9219H25.8829V18.5394H23.2686V20.2844H25.8829V22.9018H27.6258V20.2844H30.2402V18.5394Z",
    fill: "#88888F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.507 20.5987C19.958 19.8113 20.9435 18.2733 20.9435 16.5049C20.9435 13.9349 18.8626 11.8516 16.2957 11.8516C13.7289 11.8516 11.6479 13.9349 11.6479 16.5049C11.6479 18.2733 12.6334 19.8113 14.0844 20.5987C11.0395 20.8825 8.16211 23.8862 8.16211 27.5565H24.4293C24.4293 23.8862 21.5519 20.8825 18.507 20.5987Z",
    fill: "#7AB9E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2959 27.5565H24.4295C24.4295 23.8862 21.5521 20.8825 18.5072 20.5987C19.9583 19.8113 20.9437 18.2733 20.9437 16.5049C20.9437 13.9349 18.8628 11.8516 16.2959 11.8516L16.2959 27.5565Z",
    fill: "#579ADF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2394 18.5391H27.625V20.2841H30.2394V18.5391Z",
    fill: "#56545A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_33866_5230",
    x: 0.859012,
    y: 0.859012,
    width: 38.4773,
    height: 38.4773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57049
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33866_5230"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33866_5230",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserIcon);
export default __webpack_public_path__ + "static/media/addUserIcon.91a5b37f30ab4d8922380d2b47c0c4eb.svg";
export { ForwardRef as ReactComponent };